import { Injectable } from '@angular/core';
import { ParameterAsync } from 'projects/common/src/app/classes';
import { IMachineContext } from 'projects/common/src/app/interfaces/machine-context';
import { IRawApplication } from 'projects/common/src/app/interfaces/remote-models/raw-application';
import { NotificationHandlerService } from 'projects/common/src/app/services';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CommunicationService } from 'src/app/services/communication';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class MachineCollectionService extends ParameterAsync<IMachineContext[]> {
  private currentApplication: number;
  private baseUrl: string;

  constructor(
    protected http: CommunicationService,
    protected notificationService: NotificationHandlerService,
    private urlBuilderService: UrlBuilderService,
  ) {
    super(http, notificationService);
    this.name = 'machine-collection';
    this.baseUrl = this.urlBuilderService.serverBasePath;
    this.urlEndpoint = `${this.baseUrl}/Machine`;
  }

  public startWhen(source: Observable<IRawApplication>): void {
    this.subscription = source.pipe(filter((data) => !!data)).subscribe((data) => {
      this.alreadyStarted = true;
      this.currentApplication = data.menuId;
      this.init();
    });
  }

  public getMachines(): Observable<IMachineContext[]> {
    return this.http.get(this.urlEndpoint);
  }

  public getByCompany(companyId: number): Observable<any> {
    const url = `${this.baseUrl}/Report/GetMachineTypeByActiveMachines?companyId=${companyId}`;
    return this.http.get(url);
  }

  protected getArgument(): { [key: string]: any } {
    return {};
  }
}
